import { ReviewSlider } from "modules/common/components/Trustpilot/ReviewSlider";

const TrustpilotSliderAdapter = () => <ReviewSlider />;

export default TrustpilotSliderAdapter;
